import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './teams.loaders';
import { converters } from './teams.converters';
import { TeamsFilters } from './teams.types';

export const teamsKeys = queryKeyFactory('teams');

export const useTeams = (
  filters: Partial<TeamsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: teamsKeys.list(filters),
    queryFn: () => loaders.getTeams({ filters }),
    select: converters.getTeams,
    ...options,
  });
};
